const SectionTitle = ({ children, className = '' }) => {
    return (
        <h1 className={`text-2xl lg:text-3xl font-semibold text-center ${className}`}>
            {children}
        </h1>
    )
}

export default SectionTitle;
